import ct from "countries-and-timezones";
import { useState } from "react";
import { useEffect } from "react";
import { Select } from "antd";
import SC from "./style";

const CountryDropdown = (props) => {
  const {
    onSelectCallback = () => {},
    disabled = false,
    width = "250px",
    margin = "0px",
    style = {},
  } = props;
  const [countryOptions, setCountryOptions] = useState([]);
  const [country, setCountry] = useState(null);

  useEffect(() => {
    const allCountries = ct.getAllCountries();
    const countryList = Object.values(allCountries).map((country) => {
      // Get country flag emoji based on country code
      const countryCode = country.id.toUpperCase();
      const flagEmoji = getCountryFlag(countryCode);
      
      return {
        label: (
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span style={{ fontSize: '16px' }}>{flagEmoji}</span>
            <span>{country.name}</span>
          </div>
        ),
        value: country.id,
        title: country.name, // For search functionality
      };
    });
    setCountryOptions(countryList);
  }, []);

  // Function to get country flag emoji
  const getCountryFlag = (countryCode) => {
    const codePoints = countryCode
      .split('')
      .map(char => 127397 + char.charCodeAt());
    return String.fromCodePoint(...codePoints);
  };

  const handleCountryChange = (countryId) => {
    setCountry(countryId);
    onSelectCallback(countryId);
  };

  return (
    <>
      {SC.Globalstyles}
      <Select
        showSearch
        allowClear
        placeholder={"Select Country"}
        style={{ 
          width: width, 
          height: style.height || "44px", 
          margin: margin, 
          ...style 
        }}
        options={countryOptions}
        value={country}
        onChange={handleCountryChange}
        disabled={disabled}
        filterOption={(input, option) => {
          return (
            option.title.toLowerCase().includes(input.toLowerCase()) ||
            option.value.toLowerCase().includes(input.toLowerCase())
          );
        }}
      />
    </>
  );
};

export default CountryDropdown;
